require("dotenv/config");
const ApiUrl =`http://18.221.90.180:5000`
// const ApiUrl =`http://localhost:5000`
export default ApiUrl;
